export default __webpack_public_path__ + "static/media/bussiness.aa461a0a.png";